import { useMemo } from 'react';
import moment from 'moment';

/**
 * Hook to calculate health week metrics and group resources.
 * @param {string} startDate - Health week start date.
 * @param {Array} resourcesData - Raw resources data from API.
 * @returns {Object} Calculated metrics and grouped resources.
 */
const useHealthWeekMetrics = (startDate, resourcesData) => {
  const weeksElapsed = useMemo(() => {
    const start = moment(startDate || new Date());
    const diff = moment().diff(start, 'week');
    return diff <= 0 ? 1 : diff;
  }, [startDate]);

  const groupedResources = useMemo(() => {
    if (!resourcesData) return [];
    
    return [...Array(weeksElapsed).keys()].map((weekNumber) => {
      const currentWeek = weekNumber + 1;
      return {
        week: currentWeek,
        resources: resourcesData.filter((resource) => resource.week === currentWeek) || [],
      };
    });
  }, [resourcesData, weeksElapsed]);

  return {
    weeksElapsed,
    groupedResources
  };
};

export default useHealthWeekMetrics;
